import { map } from 'nanostores';
import { DEBUG_MODE } from '@/ts/enums';
import { Channels } from './channels';
import { expose } from '@/ts/utilities';

export const $store: Record<string, any> = map({
    debugLevel: DEBUG_MODE.OFF,
});

export const $channels = new Channels();
expose('$attach', $channels.attach.bind($channels));
